import { BrowserRouter as Router, useRoutes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Suspense } from 'react';

import routes from './routes';
import { RootState } from './store';

const App = () => {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  const routing = useRoutes(routes(isAuthenticated));

  return (
    <Suspense fallback={<Spinner animation="border" />}>
      {routing}
    </Suspense>
  );
};

const AppWrapper = () => (
  <HelmetProvider>
    <Router>
      <App />
    </Router>
  </HelmetProvider>
);

export default AppWrapper;
